import { FETCH_BILLING_DETAILS, UPDATE_SMS_ALERT_PREFERENCES, UPDATE_BILLING_PLAN } from "./actionTypes";

export const fetchBillingDetails = (params={}) => {
    return ({
        type: FETCH_BILLING_DETAILS,
        payload: {}
    });
}

export const updateSmsAlertPreferences = ({lowSmsBalanceReminder, smsReminderThreshold}) => {
    return ({
        type: UPDATE_SMS_ALERT_PREFERENCES,
        payload: {
            lowSmsBalanceReminder,
            smsReminderThreshold
        },
        errors: null
    });
}

export const updateBillingPlan = (payload) => {
    return ({
        type: UPDATE_BILLING_PLAN,
        payload: payload,
        errors: null
    });
}